import { Component, OnInit, Input } from '@angular/core';
import { IContentElementImage, QuestionState } from '../models';

@Component({
  selector: 'element-render-image',
  templateUrl: './element-render-image.component.html',
  styleUrls: ['./element-render-image.component.scss']
})
export class ElementRenderImageComponent implements OnInit {

  @Input() element:IContentElementImage;
  @Input() isLocked:boolean;
  @Input() isShowSolution:boolean;
  @Input() questionState:QuestionState; // not used

  constructor(
  ) { }

  ngOnInit() {
  }



}
